module.exports = "<div class=\"notification\">\n  {{ notificationMessage }}\n</div>"